import { getUserInfo, logout, getSystemMessageCount, getRealidcation } from '@/api/common.js'
import { getMyAgentInfo } from '@/api/agent.js'
import { removeToken } from '@/utils/auth' // get token from cookie
import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'

Vue.use(Vuex)


const state = {
  loading: false,
  isShowVerifyPage: false, // 是否显示认证页面
  footerActive: '',
  messageCount: '', // 消息数量
  agent: {}, // 代理ID信息
  agentInfo: {}, // 代理的个人身份信息
  userInfo: {}, // 用户信息
  userAccountInfo: {}, // 用户提现接口信息
  currentRole: 0, // 当前用户身份
  isPlus: false,
  musicStatus: { // 作品状态
    '00': '待完善资料',
    '01': '待完善资料',
    '10': '选发行范围',
    '11': '选发行范围',
    '100': '待签署授权',
    '101': '待签署授权',
    '200': '编辑审核中',
    '201': '编辑审核中',
    '300': '编辑审核中',
    '301': '编辑审核中',
    '400': '作品被驳回',
    '401': '作品被驳回',
    '990': '作品发行中',
    '991': '作品已上线'
  },
  tagTypes: {
    99: '#0DC268',
    40: '#FF3B30',
    20: '#FF8F00',
    10: '#9DA4B3',
    1: '#9DA4B3',
    0: '#9DA4B3',
  },
  mediaArr: [
    { name: '主音频', key: 'music', iconClass: 'zhuyinpin' },
    { name: '歌词', key: 'lyric', iconClass: 'geci' },
    { name: '封面', key: 'cover', iconClass: 'fengmian' },
    { name: '伴奏', key: 'accompany', iconClass: 'banzou' },
    { name: '短音频', key: 'short', iconClass: 'duanyinpin' },
    { name: 'MV视频', key: 'mv', iconClass: 'MV' },
    { name: '卡拉OK', key: 'karaoke', iconClass: 'kalaOK' }
  ],
  issueArea: { // 通过issue_area区域来选择性填充已选择的发行渠道
    0: [],
    1: ['china'],
    3: ['china', 'hongkong'],
    4: ['overseas'],
    5: ['hongkong', 'overseas'],
    7: ['china', 'hongkong', 'overseas']
  },
  areas: [
    { name: '大陆地区', key: 'china' },
    { name: '港澳台地区', key: 'hongkong' },
    { name: '海外地区', key: 'overseas' },
  ]
}

const mutations = {
  UPDATE_FOOTER_ACTIVE: (state, name) => {
    state.footerActive = name
  },
  SET_USER_INFO: (state, info) => {
    state.userInfo = info
  },
  TOGGLE_LOADING: (state, status) => {
    state.loading = status
  },
  TOGGLE_VERIFY: (state, status) => {
    state.isShowVerifyPage = status
  },
  SET_USER_ACCOUNT_INFO: (state, info) => {
    state.userAccountInfo = info
  },
  GET_AGENT_ID: (state, info) => {
    state.agent = info
  },
  SET_MESSAGE_COUNT: (state, count) => {
    state.messageCount = count
  },
  TOGGLE_ROLE: state => {
    state.currentRole = state.currentRole === 0 ? 1 : 0
  },
  SET_ROLE: (state, status) => {
    state.currentRole = status
  },
  SET_ENV: (state, status) => {
    state.isPlus = Boolean(status)
  },
  SET_AGENT_INFO: (state, info) => {
    state.agentInfo = info
  }
}

const actions = {
  // 获取代理商ID
  getAgentId({ commit }) {
    return new Promise((resolve, reject) => {
      const hostname = location.hostname === 'localhost' ? 'www.musickkk.com' : location.hostname
      const params = { domain: hostname }
      Axios.get('/api/agent/info', { params }).then(res => {
        commit('GET_AGENT_ID', res.data.data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  setFooterAction({ commit }, params) {
    commit('UPDATE_FOOTER_ACTIVE', params)
  },
  async getUserInfo({ commit }) {
    try {
      const res = await getUserInfo({})
      const count = await getSystemMessageCount({ role_type: state.currentRole })
      commit('SET_MESSAGE_COUNT', count.data)
      commit('SET_USER_INFO', { ...res.data.userinfo, android_version: res.data.android_version})
      commit('SET_USER_ACCOUNT_INFO', { ...res.data.user_account_info, rate: res.data.rate, real_name: res.data.real_name })
    } catch {
      removeToken()
    }
  },
  async getRealidcation(store, payLoad) {
    let res = ''
    try {
      res = await getRealidcation(payLoad)
      return res
    } catch {
      this.msg = res.msg
    }
  },
  async getAgentInfo({ commit }) {
    const res = await getMyAgentInfo({})
    commit('SET_AGENT_INFO', res.data)
  },
  async logout() {
    await logout({})
    removeToken()
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})
